<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/teamtransaction/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            :show="false"
        >
            <el-form-item label="代理商ID">
                <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="操作时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table
            :data="tableData"
            ref="commonTable"
            @handleChange="getPage"
            :isShow="false"
        >
            <el-table-column
                prop="parentId"
                label="上级代理商ID"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="memId"
                label="代理商ID"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="realName"
                label="代理商姓名"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="phoneNumber"
                label="代理商手机号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="transaction"
                label="团队交易量"
                :formatter="formatterTableNumber"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="number"
                label="交易笔数"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import StatisticsService from "service/StatisticsService";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "teamtransaction",
        components: {
            CommonTopForm,
            CommonTable,
        },
        data() {
            return {
                formModel: {
                    userId: "",
                    time: "",
                },
                tableData: [],
                submitService: StatisticsService.teamtransactionList,
                params: {},
                page: {},
                isPage: false,
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == "") {
                    this.formModel.time = [];
                }
                const params = {
                    userId: this.formModel.userId,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length) {
                    params.startDate = this.formModel.time[0];
                    params.endDate = this.formModel.time[1];
                }
                return params;
            },
            ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
        },
        methods: {
            load() {
                this.formModel = {
                    time: "",
                };
                this.page = this.$refs.commonTable.page;
                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/Statistics/TeamTransaction.vue